// @ts-nocheck 35cdca57
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_video'],
      sections: [addPanel.sections.getSections().video.youTubeStyleSection],
    };
  },
};
